const CURRENT_ENV = process.env.ENVIRONMENT || 'development';

// These values come from whichever .env.* file React loaded
const { REACT_APP_API_URL, REACT_APP_WEB_BASE_URL } = process.env;

// Export constants (use the values React already injected)
export const BASE_URL = REACT_APP_API_URL!;
export const WEB_BASE_URL = REACT_APP_WEB_BASE_URL!;

// Optional helper to know which environment is active
export const getCurrentEnvironmentInfo = () => ({
  environment: CURRENT_ENV,
  baseUrl: BASE_URL,
  webBaseUrl: WEB_BASE_URL,
});
